module.exports = "/_next/static/images/333de355c313a30fb3902ae56b5e5a0b-roxinho-scene-card-with-phone-md@2x.jpg.webp";